export const AIS_ROUTES = {
    FILE_EXCHANGE_ENTITY_NAME: 'ais3.file.exchange',
    MONITOR_SERVICES: 'ais3.monitor.services',
    DOCUMENTS_REGISTER: 'ais3.doc.journal',
    DOCUMENTS_BY_TAX_REGISTER: 'ais3.doc.journal.by.tax',
    DOCUMENTS_INTERFACE: 'ais3.doc.journal.interface',
    RECLAIMING_INFORMATION: 'ais3.reclaiming.information',
    DOCUMENT_CODES: 'ais3.document.codes',
    COMMENTS_REQUEST_RESULT: 'ais3.comments.request.result',
    ORGANIZATION_STRUCTURE: 'organization.structure',
    NOTIFICATION_SCENARIOS_SETTINGS: 'ais3.scenario.notification.settings',
    EXPLANATION_INFORMATION: 'ais3.explanation.information',
    SUMMARY_TRANSACTIONS_PROTOCOL_INTERFACE: 'ais3.summary.transactions.protocol.interface',
    TAX_FORECAST: 'ais3.income.tax.forecast',
    RISKS_DOCUMENTS_MAPPING: 'ais3.risks.documents.mapping',
    RISKS_REQUESTS: 'ais3.risks.requests',
    FORECAST_COMMENTS: 'ais3.excise.tax.forecast',
    ORGANIZATION_STRUCTURE_V5: 'ais3.organization.structure.v5',
    COMMENTS_REQUEST_RESULT_ND: 'ais3.comments.request.result.nd',
};
export const AisDocumentTypeCodesEntityName = {
    DOCUMENT_TYPE_CODES_DIRECTORY: 'ais3.document.type.codes.directory',
    PRIMARY_DOCUMENTS_CODES_SETTINGS: 'ais3.primary.documents.codes.settings',
};
export const AisDocumentDocumentCodesTabKey = {
    REFERENCE_BOOK_DOCUMENT_CODES: 'referenceBookDocumentCodes',
    SETTING_DOCUMENT_CODES: 'settingDocumentCodes',
};

export const DocumentCodesFormTitles = {
    [AisDocumentDocumentCodesTabKey.REFERENCE_BOOK_DOCUMENT_CODES]: 'Справочник кодов видов документов',
    [AisDocumentDocumentCodesTabKey.SETTING_DOCUMENT_CODES]: 'Настройка кодов для первичных документов',
} as const;

export const AIS_FILE_EXCHANGE_ENTITY_NAME_SECTION_CODE = `app.${AIS_ROUTES.FILE_EXCHANGE_ENTITY_NAME}`;
export const AIS_ENTITY_NAME = 'ais3';
